var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-area"},[_c('Word'),_c('Hive'),_c('Controls')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }